import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { SidenavItemLink } from './Sidenav.Item.Link.es.js';
import { SidenavItemRow } from './Sidenav.Item.Row.es.js';

// Type guard to check if props has href
function isLinkProps(props) {
    return 'href' in props;
}
const SidenavItem = /*#__PURE__*/ forwardRef((props, ref)=>{
    // Check if this is a link by looking for the href property
    if (isLinkProps(props)) {
        return jsx(SidenavItemLink, {
            ...props,
            ref: ref
        });
    }
    // Default to row type (no href)
    return jsx(SidenavItemRow, {
        ...props
    });
});
SidenavItem.displayName = 'Sidenav.Item';

export { SidenavItem };
//# sourceMappingURL=Sidenav.Item.es.js.map
